import { Button, ButtonGroup, Link } from "@chakra-ui/react"
import { BsFileText, BsPencilSquare, BsTrash } from "react-icons/bs"
import { itemData, AL_DELETE, AL_INFO, useSelectedItemAlertContext } from "../../context/selectedItemAlertContext"
import { Link as ReactLink } from "react-router-dom"

const TableButtonFormUserGroup = ({ row, size = "xs" }) => {
    const { setItemData } = useSelectedItemAlertContext()
    const enableEdit = row.form_status_id === 1 || row.form_status_id === 3
    const enableCancel = row.form_status_id <= 3

    const viewInfoHandle = (id) => {
        setItemData(itemData(id, AL_INFO))
    }

    const cancelHandle = (data) => {
        const { id, form_status_id, residence_name } = data

        if (form_status_id <= 3) {
            // delete
            const body = `คำร้องขอเข้าพัก ${residence_name}`
            setItemData(itemData(id, AL_DELETE, '', body))
        } else {
            alert('สถานะแบบฟอร์มไม่ถูกต้อง')
        }
    }

    return (
        <ButtonGroup spacing={2} size={size}>
            <Button leftIcon={<BsFileText />} colorScheme="blue" onClick={() => viewInfoHandle(row.id)} >ข้อมูล</Button>
            <Link as={ReactLink} to={`/form/${row.id}/edit`} _hover={{ textDecoration: 'none' }}>
                <Button leftIcon={<BsPencilSquare />} colorScheme="yellow" disabled={!enableEdit} >แก้ไข</Button>
            </Link>
            <Button leftIcon={<BsTrash />} colorScheme="red" disabled={!enableCancel} onClick={() => cancelHandle(row)} >ลบ</Button>
        </ButtonGroup>
    )
}

export default TableButtonFormUserGroup